import { Pipe, PipeTransform } from '@angular/core';
import { TicketPL } from '../enums/ticket-pl';
import { Ticket } from '../models/entities/ticket';



@Pipe({
  name: 'ticket-pipe'
})

export class TicketPipe implements PipeTransform {
  
  constructor(){}

  transform(ticket: Ticket, field: string): any {
    let result = ticket[field];

     if (field == 'progressLevel') {
      if  (result == TicketPL.pl_newly_created)  return "<div class='label-red'>"         + 'Nouveau' + "</div>";
      if  (result == TicketPL.pl_to_be_qualified)return "<div class='label-darkOrange'>"  + 'A Requalifier'    + "</div>";
      if  (result == TicketPL.pl_qualified)      return "<div class='label-orange'>"      + 'Qualifié'    + "</div>";
      if  (result == TicketPL.pl_scheduled)      return "<div class='label-blue'>"        + 'Planifié'    + "</div>";
      if  (result == TicketPL.pl_processed)      return "<div class='label-green'>"       + 'Traité'      + "</div>";
      if  (result == TicketPL.pl_closed)         return "<div class='label-gray'>"        + 'Cloturé'      + "</div>";
    }

    if (field == 'priority') {
      if  (result == 1)  return "<div class='label-gray'>"        + 'Faible' + "</div>";
      if  (result == 2)  return "<div class='label-orange'>"      + 'Normal' + "</div>";
      if  (result == 3)  return "<div class='label-red'>"         + 'Haute' + "</div>";
    }
    return result;
  }
}
